export enum DocumentEnum {
  PATENT = "PATENT",
  ARTICLE = "ARTICLE",
  INTERNAL_DOCUMENT = "INTERNAL_DOCUMENT",
}
